// extracted by mini-css-extract-plugin
export default {"authorWrapper":"AuthorWrapper_authorWrapper__-c69G","authorWrapperGrid":"AuthorWrapper_authorWrapperGrid__R2bcG"};